import * as Url from "./urls";
import Axios from "axios";

const getCommonHeaders = () => {
  const token = localStorage.getItem("ID_TOKEN");
  const subscriptionKey = process.env.REACT_APP_SUBSCRIPTION_KEY;
  return {
      "x-lang-code": "en",
      "Cache-Control": "no-cache",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "Ocp-Apim-Subscription-Key": subscriptionKey,
  };
};

//Salary ADvance

export const getSalaryProfile = (request) => {
  return Axios.post(Url.getSalaryProfile, request);
};
export const getSalaryAdvancedetails = (employeeData) => {
  return Axios.get(
    `${Url.getSalaryAdvancedetails}?citizenID=${employeeData.citizenId}`,
    {
      headers: getCommonHeaders(),
    }
  );
};
export const getSalaryHistory = (employeeData) => {
  return Axios.get(
    `${Url.getSalaryHistory}?citizenID=${employeeData.citizenId}`,
    {
      headers: getCommonHeaders(),
    }
  );
};

export const checkEligibilty = (employeeData) => {
  let request = {
    citizenID: employeeData.citizenId,
    CorporateId: employeeData.corporateId,
  };
  return Axios.post(Url.checkEligibilty, request, {
    headers: {
      ...getCommonHeaders(),
      "x-source-client": "C3Pay",
    },
  });
};
